var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconSessionBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#212121",
    strokeWidth: 1.5,
    fill: "transparent",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.478 3.475A12.941 12.941 0 0 1 27.231 10a12.94 12.94 0 0 1-1.981 6.902M3.003 3.475A12.941 12.941 0 0 0 1.25 10c0 2.536.726 4.902 1.981 6.902M23.231 10h0a9 9 0 0 1-9 9h0a9 9 0 0 1-9-9h0a9 9 0 0 1 9-9h0a9 9 0 0 1 9 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.172 7.058 3.882 2.296a.75.75 0 0 1 0 1.291l-3.882 2.296a.75.75 0 0 1-1.132-.646V7.704a.75.75 0 0 1 1.132-.646h0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSessionBlack);
export default __webpack_public_path__ + "static/media/iconSessionBlack.1f8771587f1027ce951f41452ecf319b.svg";
export { ForwardRef as ReactComponent };